import React, { Component } from "react";
import "./App.scss";
import "./branding.scss";
import "./source-css/main-css.scss"
import "./source-css/branding.scss"
import "./source-css/structures.scss"
import "./components/Translations";
import PageLayout from "./components/PageLayout";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import ContactPage from "./components/ContactPage/ContactPage";
import { RootStore, StoreProvider } from "./Store";
import SignalrClientComponent from "./components/SignalrClientComponent";
import NCTOMainBody from "./components/Body/NCT/NCTOMainBody";
import LoadingPage from "./components/LoadingPaget";
import LoadingStoreRoute from "./Routes/LoadingStoreRoute";
import ShortLinkRoute from "./Routes/ShortLinkRoute";
import SessionRoute from "./Routes/SessionRoute";
import InvalidLinkPage from "./Routes/InvalidLinkPage";

class App extends Component<{ store?: RootStore }> {
  render() {
    return (
      <div className="App">
        <StoreProvider store={this.props.store}>
          <SignalrClientComponent />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoadingPage />} />
              <Route path="/s/:code" element={<ShortLinkRoute />} />
              <Route path="/app" element={<SessionRoute><PageLayout /></SessionRoute>} />
              <Route path="/abroad" element={<SessionRoute><NCTOMainBody /></SessionRoute>} />
              <Route path="/contact" element={<SessionRoute><ContactPage /></SessionRoute>} />
              <Route path="/:conceptId/:caseId" element={<LoadingStoreRoute />} />
              <Route path="/NotAuthorized" element={<InvalidLinkPage />} />
              <Route path="/invalid-link" element={<InvalidLinkPage />} />
              <Route path="*" element={<InvalidLinkPage />} />
            </Routes>
          </BrowserRouter>
        </StoreProvider>
      </div>
    );
  }
}

export default App;
